import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { HttpClientService } from './http-client.service';
import { HttpErrorHandler } from './http-error-handler';

import { NgResponse } from '../shared/ng-response';

import { AppContext } from '../app.context';
import { NgRequest } from "../shared/ng-request";
import { FilterSortPageRequest } from "../shared/grid.model";
import { EntitiesByTypeRequest, ViewItemsResponse } from "../shared/entity.model";

@Injectable()
export class EntitiesService extends HttpClientService {
  constructor(
    readonly appContext: AppContext,
    readonly httpClient: HttpClient,
    readonly httpErrorHandler: HttpErrorHandler) {
    super('SecurityService', httpClient, httpErrorHandler);
  }

  fetchEntitiesByType(request: NgRequest<FilterSortPageRequest<EntitiesByTypeRequest>>): Observable<NgResponse<ViewItemsResponse>> {
    return this.postBody<FilterSortPageRequest<EntitiesByTypeRequest>, ViewItemsResponse>('fetchItems', 'api/Entities/Items', request);
  }
}
